import { gql } from "@apollo/client";

export const GET_USER_GUIDES_DOC_LIST = gql`
    query getUserGuides{
        getUserGuidesDocList{        
            groupName
            sortOrder
            groupSortOrder
            userGuideGroupId
            userGuideId
            userGuideName
            details {
            language
            userGuideBlob
            }          
        }
    }
`;

export const DOWNLOAD_USER_GUIDE_DOCUMENT_QUERY_BY_BLOB_ID = gql`
    query downloadUserGuideDocument($blobId: Float!){
        downloadUserGuideDocument(blobId : $blobId)
        {
            success
            value {
                encodedFileData
                fileName
                mimeType
                }
            }
    }
`;

export const GET_ALL_USER_GUIDES = gql`
  query GetAllUserGuides {
    getAllUserGuides {
      userGuideId
      userGuideNamePhraseId
      sortOrder
      insertUser
      insertDate
      updateUser
      updateDate
      userGuideGroup {
        userGuideGroupId
        userGuideGroupNamePhraseId
        sortOrder
      }
      translations {
        languageCode
        phraseId
        translation
      }
      userGuideBlobs {
        userGuideBlobId
        language
        blob {
          blobId
          downloadLink
          fileName
          mimeType
        }
      }
    }
  }
`;

export const GET_USER_GUIDE = gql`
  query GetUserGuide($id: Float!) {
    getUserGuide(id: $id) {
      userGuideId
      userGuideNamePhraseId
      sortOrder
      insertUser
      insertDate
      updateUser
      updateDate
      userGuideGroup {
        userGuideGroupId
        userGuideGroupNamePhraseId
        sortOrder
      }
      translations {
        languageCode
        phraseId
        translation
      }
      userGuideBlobs {
        userGuideBlobId
        language
        blob {
          blobId
          downloadLink
          fileName
          mimeType
        }
      }
    }
  }
`;

export const GET_ALL_USER_GUIDE_GROUPS = gql`
  query GetAllUserGuideGroups {
    getAllUserGuideGroups {
      userGuideGroupId
      userGuideGroupNamePhraseId
      sortOrder
      insertUser
      insertDate
      updateUser
      updateDate
      translations {
        languageCode
        phraseId
        translation
      }
    }
  }
`;

export const GET_USER_GUIDE_UPLOAD_LANGUAGES = gql`
  query getUserGuideUploadLanguages {
    getUserGuideUploadLanguages {
        languages
    }
}
`;
